'use client';

import React, { useEffect } from 'react';
import Footer from '@/components/shared/Footer/Footer';
import Navbar from '@/components/shared/Navbar/Navbar';
import SpeedDial from '@/components/shared/SpeedDail/SpeedDail';
import WelcomeModal from '@/components/shared/Welcome/WelcomeModal';
import Chatbot from '@/components/ChatBot/Chatbot';
import NotAvailable from '@/components/NotAvailable/NotAvailable';

const MainLayout = ({ children }) => {
  return (
    <div className='min-h-screen flex flex-col max-w-[120rem] mx-auto'>
      <main>
        {/* <WelcomeModal />
        <Navbar />
        {children}
        <SpeedDial />
        <Chatbot />
        <Footer /> */}
        <NotAvailable />
      </main>
    </div>
  );
};

export default MainLayout;
